export default {
  series: 1,
  data: 'Series 1 (x);Series 1 (y)\n0;100\n1;200\n2;-100\n3;-50',
};
